<template lang="pug">
  .ripples-container(v-if="isVisible")
    span.ripples
</template>

<script>
export default {
  name: 'Ripples',
  data () {
    return {
      isVisible: true
    }
  },
  mounted () {
    const ripples = this.$el.querySelector('.ripples')
    ripples.addEventListener('animationend', () => {
      this.isVisible = false
    })
  }
}
</script>

<style lang="styl" scoped>
  .ripples-container
    position relative
    width 100%

  .ripples, .ripples:before
    position absolute
    top 50%
    left 50%
    transform translate(-50%,-50%)
    border-radius 50%
    animation ripples 2s 1

  .ripples:before
    content: ""

  .ripples:before
    animation-delay 0.1s

  @keyframes ripples
    0%
      width 0
      height 0
      border 4px solid #7C4DFFAA

    100%
      width 1000px
      height 1000px
      border 4px solid #7C4DFF00

  .popup:after
    content attr(data-content)
    font-size 1.5em
</style>
